<template>
  <div>
    <app-download-screen></app-download-screen>
    <modal
      @cancel="setIsOpen(false)"
      v-if="view === null"
      :title="modalTitleCreate"
      :open="isOpen"
      :buttons="false"
    >
      <div
        class="action-box"
        @click="changeView('email')"
        data-action="lead.create-from-email"
      >
        <img class="enter-email" src="../../../../assets/enter-email.svg" />
        <p>{{ $t("models.project_lead.message.create_from_email") }}</p>
      </div>
      <div
        class="ios-workaround"
        v-if="
          browser.name == 'crios' ||
            browser.name == 'fxios' ||
            browser.name == 'ios'
        "
      >
        <label
          for="businesscard_upload"
          class="action-box"
          data-action="lead.create-from-card"
        >
          <img class="capture-card" src="../../../../assets/scan-card.svg" />
          <input
            class="ios_only ios-photo-input"
            @change="uploadedImage"
            id="businesscard_upload"
            type="file"
            accept="image/*"
            capture="camera"
          />
          <p>{{ $t("models.project_lead.message.create_from_card") }}</p>
        </label>
      </div>
      <div v-else>
        <div
          class="action-box"
          @click="changeView('card')"
          data-action="lead.create-from-card"
        >
          <img class="capture-card" src="../../../../assets/scan-card.svg" />
          <p>{{ $t("models.project_lead.message.create_from_card") }}</p>
        </div>
      </div>
    </modal>
    <modal
      v-else-if="view === 'email'"
      :title="modalTitleCreate"
      :saveText="modalSaveTextEmail"
      :open="isOpen"
      @save="confirmEmail"
      @cancel="setIsOpen(false)"
    >
      <field
        v-model="email"
        :errors="errors"
        model="project_lead"
        name="email"
        placeholder="lead@company.com"
      />
    </modal>
    <modal
      v-else-if="view === 'card'"
      :title="modalTitleCreate"
      :open="isOpen"
      :saveText="modalSaveTextWebcam"
      @save="takePhoto"
      @cancel="setIsOpen(false)"
      class="lead-create-modal"
    >
      <vue-webcam ref="webcam" />
    </modal>
    <modal
      v-else-if="view === 'api-error'"
      :title="$t('errors.api_error_modal.select_company')"
      :saveText="modalSaveTextContinue"
      :open="isOpen"
      @save="resolveApiError(true)"
      @cancel="setIsOpen(false)"
    >
      <user-api-choice
        :error="apiError"
        :listItems="apiErrorAttributes"
        :includeCtaButton="true"
        ctaButtonText="Continue"
        :caption="$t('errors.api_error_modal.select_company_caption')"
        @resolve="resolveApiError"
      />
    </modal>
  </div>
</template>

<script>
import Field from "@/components/helpers/DataInput/Field";
import VueWebcam from "@/components/helpers/DataInput/VueWebcam";
import Loading from "@/components/helpers/Specific/Loading.vue";
import Api from "@/api/Lead";
import ProjectApi from "@/api/Project.js";
import Ui from "@/classes/Ui";
import { detect } from "detect-browser";
import UserApiChoice from "@/components/helpers/DataDisplay/UserApiChoice";
import Modal from "@/components/helpers/Layout/NewModal";
import { EventBus } from "@/EventBus.js";
import AppDownloadScreen from "@/components/layouts/partials/AppDownloadScreen";
export default {
  components: {
    Field,
    VueWebcam,
    Loading,
    UserApiChoice,
    Modal,
    AppDownloadScreen
  },
  props: ["id"],
  data() {
    return {
      isOpen: false,
      email: null,
      apiError: {},
      errors: [],
      view: null,
      email: "",
      photo: null,
      loading: false,
      browser: detect(),
      debug: {},
      apiErrorAttributes: ["website", "street", "street_number", "zip", "city"]
    };
  },
  computed: {
    modalTitleCreate() {
      return this.$t("ui.pages.lead-create");
    },
    modalSaveTextEmail() {
      return this.$t("ui.button.project_leads.create");
    },
    modalSaveTextWebcam() {
      return this.$t("ui.button.project_leads.create");
    },
    modalSaveTextContinue() {
      return this.$t("ui.button.project_leads.continue");
    },
    currentPlanIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent;
    },
    realDebug() {
      return this.debug;
    },
    lead() {
      return this.$store.getters.getCurrentLead;
    }
  },
  mounted() {
    Ui.setPageLevel(3);
    // set subtitle
    let project_api = new ProjectApi();
    project_api.show(this.id);

    // Empty lead data to go  in Vuex
    this.$store.commit("EMPTY_LEAD");

    EventBus.$on("action", this.handleAction);

    // If current plan is Talent we don't support capturing with scan
    if (this.currentPlanIsTalent) {
      this.view = "email";
    }
  },
  methods: {
    uploadedImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = e => {
        const dataURI = e.target.result;
        if (dataURI) {
          this.$emit("load", dataURI);
          this.photo = dataURI;
          this.createFromBusinessCard();
        }
      };
      reader.readAsDataURL(file);
    },
    mailChange() {},
    handleAction(action) {
      if (action == "project_leads.add_popup") {
        this.setIsOpen(true);
      }
    },
    setIsOpen(bool) {
      this.isOpen = bool;
      if (!bool && !this.currentPlanIsTalent) {
        this.view = null;
      }
    },
    takePhoto() {
      this.photo = this.$refs.webcam.getPhoto();
      this.createFromBusinessCard();
    },
    changeView(view) {
      if (view === null) {
        this.photo = null;
        this.lead.email = null;
      }
      this.view = view;
    },
    async createFromBusinessCard() {
      Ui.startLoading();
      let api = new Api("v2");
      let data = {
        project_id: this.id,
        business_card_data: this.photo,
        origin: "web_app"
      };
      try {
        let item = await api.upload_business_card(data);
        this.new_lead = item;
        this.setNotification(item);
        this.closePopupAndContinue(item);
      } catch (e) {
        this.errors = e.response.data.errors;
        this.handleApiError(e);
      } finally {
        Ui.finishLoading();
        this.loading = false;
      }
    },
    async createFromEmail() {
      let api = new Api();
      try {
        this.lead.origin = "web_app";
        let item = await api.post(this.lead);
        this.new_lead = item;
        this.setNotification(item);
        this.closePopupAndContinue(item);
      } catch (e) {
        this.errors = e.response.data.errors;
        this.handleApiError(e);
      } finally {
        this.loading = false;
      }
    },
    handleApiError(error) {
      let apiResponse = JSON.parse(error.request.response);
      if (apiResponse.errors.length === 0) {
        // TODO add error handling
      } else {
        this.apiError = apiResponse;
        this.view = "api-error";
      }
    },
    setNotification(res) {
      // If it includes lead it means the lead already exists. Don't show a notification.
      if (!res.found_existing || !res.found_existing.includes("lead")) {
        this.$store.commit("SET_NOTIFICATION", {
          title: this.$t("models.project_lead.created"),
          type: "success"
        });
      }
      if (res.found_existing && res.found_existing.length > 0) {
        if (res.found_existing.includes("name")) {
          this.$store.commit("SET_NOTIFICATION", {
            title: "models.project_lead.predicted_name",
            type: "info"
          });
        } else {
          this.$store.commit("SET_NOTIFICATION", {
            title: "models.project_lead.found_existing",
            type: "info"
          });
        }
      }
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    resolveApiError(isCta, choice) {
      if (!isCta) {
        this.updateLead({
          company: choice.name
        });
      } else {
        this.updateLead({
          overwrite_conflict: true
        });
      }
      this.confirmEmail();
    },
    confirmEmail() {
      this.loading = true;
      this.$store.commit("UPDATE_CURRENT_LEAD", {
        email: this.email,
        project_id: this.id
      });
      this.createFromEmail();
    },
    updateLead(params) {
      this.$store.commit("UPDATE_CURRENT_LEAD", params);
    },
    closePopupAndContinue(item) {
      let params = { lead_id: item.id, project_id: this.id };
      this.$store.commit("SET_EMPTY_STATE", null);
      this.$emit("close");
      this.$router.push({ name: "project_lead_edit", params: params });
    }
  }
};
</script>
<style lang="sass">
@media (max-width: 575px)
  .lead-create-modal
    .modal-wrapper
      min-width: 100%
      width: 320px
    .modal-component
      padding: 1em 0 !important
      text-align: center !important
</style>
<style lang="sass" scoped>
.action-box
  padding: 0.8em
  background: $paper-lighter
  text-align: center
  box-shadow: 0 0 9px 0 rgba(189, 189, 189, 0.18)
  border-radius: 3px
  display: block
  margin-top: 0

.download-app
  display: flex
  justify-content: center
  margin: 7px 0 0
  img
    height: 30px

.ios-photo-input
  display: none

input.is-hidden
  display: none

.lead-create--step-1, .lead-create--step-2
  padding: 40px

.lead-create--step-1, .lead-create--step-2, .lead-create--step-3
  position: relative
  .actions
    border: 0
    text-align: center
    margin-top: 1em
    .btn
      margin-bottom: 5px

.lead-create--step-3 .webcam
  position: relative
  .actions
    position: absolute
    right: 20px
    top: 50%
    transform: translateY(-50%)
    .camera-button
      width: 65px
      height: 65px
      display: inline-block
      background-color: #ffd800
      border: solid 8px #2d2d2d

.lead-create--step-3 .grid-2
  position:relative

.camera-button
  background: $color-white
  border-radius: 50%
  padding: 0.5em
  z-index: 5
  user-select: none

.action-box
  cursor: pointer
  padding: 3em
  transition: .4s all ease-in-out
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  width: 100%
  height: 200px
  margin-bottom: 1em

  &:hover
    background: $paper-light

  @media(max-width:575px)
    margin-top: 1em

  .icon
    font-size: 2.5em

  p
    margin-top: 1em
    font-size: 1em
    color: $ink-dark


  .enter-email, .capture-card
    max-width: 100px

.lead-create--step-2,
.lead-create--step-4
  .button
    flex-grow: 1
    align-self: center

  .email
    flex-grow: 10

  .confirm
    flex-grow: 2
    text-align: right
    align-self: center

.fade-enter-active
  transition: opacity 0.15s ease-out

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  opacity: 0

.lead-create--step-3
  .preview
    position: relative
    min-height: 10em
    .btn-rounded
      background: $color-white

  .webcam
    position: relative
    overflow: hidden
    video
      object-fit: cover
      height: auto

.lead-create--step-2
  min-width: 480px
  .action
    text-align: center
    display: flex
    justify-content: center

.ios-workaround
  .back-button
    top: 0
    left: 0

  .actions
    margin-bottom: 15px

  .field
    margin-bottom: 10px
    text-align: center
    label
      margin-top: 0

    input
      width: 0.1px
      height: 0.1px
      opacity: 0
      overflow: hidden
      position: absolute
      z-index: -1
</style>



// WEBPACK FOOTER //
// LeadCreate.vue?386d41c1